var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.61,18.99 L13.53,9.91 C14.46,7.57 13.98,4.81 12.09,2.91 C9.79,0.61 6.21,0.4 3.66,2.26 L7.5,6.11 L6.08,7.52 L2.25,3.69 C0.39,6.23 0.6,9.82 2.9,12.11 C4.76,13.97 7.47,14.46 9.79,13.59 L18.9,22.7 C19.29,23.09 19.92,23.09 20.31,22.7 L22.61,20.4 C23.01,20.02 23.01,19.39 22.61,18.99 Z M19.61,20.59 L10.15,11.13 C9.54,11.58 8.86,11.85 8.15,11.95 C6.79,12.15 5.36,11.74 4.32,10.7 C3.37,9.76 2.93,8.5 3,7.26 L6.09,10.35 L10.33,6.11 L7.24,3.02 C8.48,2.95 9.73,3.39 10.68,4.33 C11.76,5.41 12.17,6.9 11.92,8.29 C11.8,9 11.5,9.66 11.04,10.25 L20.49,19.7 L19.61,20.59 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.61,18.99 L13.53,9.91 C14.46,7.57 13.98,4.81 12.09,2.91 C9.79,0.61 6.21,0.4 3.66,2.26 L7.5,6.11 L6.08,7.52 L2.25,3.69 C0.39,6.23 0.6,9.82 2.9,12.11 C4.76,13.97 7.47,14.46 9.79,13.59 L18.9,22.7 C19.29,23.09 19.92,23.09 20.31,22.7 L22.61,20.4 C23.01,20.02 23.01,19.39 22.61,18.99 Z M19.61,20.59 L10.15,11.13 C9.54,11.58 8.86,11.85 8.15,11.95 C6.79,12.15 5.36,11.74 4.32,10.7 C3.37,9.76 2.93,8.5 3,7.26 L6.09,10.35 L10.33,6.11 L7.24,3.02 C8.48,2.95 9.73,3.39 10.68,4.33 C11.76,5.41 12.17,6.9 11.92,8.29 C11.8,9 11.5,9.66 11.04,10.25 L20.49,19.7 L19.61,20.59 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.61,18.99 L13.53,9.91 C14.46,7.57 13.98,4.81 12.09,2.91 C9.79,0.61 6.21,0.4 3.66,2.26 L7.5,6.11 L6.08,7.52 L2.25,3.69 C0.39,6.23 0.6,9.82 2.9,12.11 C4.76,13.97 7.47,14.46 9.79,13.59 L18.9,22.7 C19.29,23.09 19.92,23.09 20.31,22.7 L22.61,20.4 C23.01,20.02 23.01,19.39 22.61,18.99 Z M19.61,20.59 L10.15,11.13 C9.54,11.58 8.86,11.85 8.15,11.95 C6.79,12.15 5.36,11.74 4.32,10.7 C3.37,9.76 2.93,8.5 3,7.26 L6.09,10.35 L10.33,6.11 L7.24,3.02 C8.48,2.95 9.73,3.39 10.68,4.33 C11.76,5.41 12.17,6.9 11.92,8.29 C11.8,9 11.5,9.66 11.04,10.25 L20.49,19.7 L19.61,20.59 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.c53004a4985742c06b1b42894c669e1e.svg";
export { ForwardRef as ReactComponent };